import React, { useCallback, useContext, useEffect, useState } from "react";
import Aggrid from "../../framework/AgGrid";
import GlobalContext from "../../framework/GlobalContext";
import { getRoleLogs } from "../../services/roles-service";
import { rowDown, rowUp, selectRow } from "../../utils/gridUtils";
import { roleLogsColDefs } from "./constants";
import c from "./RoleLogs.module.css";

const RoleLogs = ({ onEscape = () => {} }) => {
  const [rowData, setRowData] = useState(null);
  const [api, setApi] = useState(null);
  const { setCurrentComponent } = useContext(GlobalContext);
  const keyupListener = useCallback(
    (e) => {
      if (!api) return;
      const key = e.key.toLowerCase();
      const ctrlKey = e.ctrlKey;
      if (key === "arrowdown") {
        rowDown(api, ctrlKey);
        return;
      }
      if (key === "arrowup") {
        rowUp(api, ctrlKey);
        return;
      }
      if (key === "escape") {
        return onEscape();
      }
    },
    [api, onEscape]
  );
  useEffect(() => {
    if (!rowData) {
      getRoleLogs().then((r) => {
        setRowData(r);
      });
    }
  }, [rowData]);
  useEffect(() => {
    setCurrentComponent("grid_role_logs");
  }, [setCurrentComponent]);
  useEffect(() => {
    document.addEventListener("keyup", keyupListener, false);
    return () => document.removeEventListener("keyup", keyupListener, false);
  }, [keyupListener]);
  return (
    <div className={c["logs"]}>
      <Aggrid
        id="grid_role_logs"
        columnDefs={roleLogsColDefs}
        rowData={rowData}
        onGridReady={(params) => {
          setApi(params.api);
          params.api.sizeColumnsToFit();
        }}
        onRowDataChanged={(params) => {
          selectRow(params.api, 0);
        }}
      />
    </div>
  );
};

export default RoleLogs;
